import React from 'react';
import loadable from '@loadable/component';
import App from 'containers/App/App';
import Landing from 'containers/Landing/Landing';
import Games from 'containers/Games/Games';
import Affiliate from './containers/Affiliate/Affiliate';
import Races from './containers/Races/Races';
import Account from './containers/Account/Account';
import staticPages from './static/staticPages';
import Loader from './components/Loader/Loader';

const StaticPage = loadable(() => import('./static/StaticPage'), { fallback: <Loader /> });

const routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        exact: true,
        component: Landing,
      },
      {
        path: staticPages.map(({ path }) => path),
        exact: true,
        component: StaticPage,
      },
      {
        path: '/account',
        component: Account,
      },
      { path: '/partners', component: Affiliate },
      {
        path: '/games/:gameUrl?',
        component: Games,
      },
      {
        path: '/races',
        exact: true,
        component: Races,
      },
      {
        path: '*',
        exact: true,
        component: Landing,
      },
    ],
  },
];

export default routes;
